import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import useToastContext from '@/hooks/useToastContext';
import documentationServices from '@/services/documentationServices';
import { IcoButtonSimple } from '@/components/UI/IcoButton/IcoButton';
import Spinner from '@/components/UI/Spinner/Spinner';
import DialogOpenImage from './DialogOpenImage';
import styles from './Image.module.scss';

interface ImageProps {
  src: string;
  id: string;
  name: string;
  type: string;
  className?: string;
}

const Image: React.FC<ImageProps> = ({ src, id, name, type, className }) => {
  const { addToast } = useToastContext();
  const { t } = useTranslation();
  const [image, setImage] = useState('');
  const [image64, setImage64] = useState('');
  const [dialog, setDialog] = useState({
    show: false,
    title: '',
    message: 'dialog.default',
    btnText: 'dialog.close',
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    setImage(src);
    setTimeout(() => setIsLoading(false), 1000);
  }, [src]);

  const backgroundColorWithImage = image !== '' ? styles.BackgroundColorWithImage : '';

  const onOpenImage = () => {
    documentationServices.getDownload(id)
      .then((res) => {
        const url = window.URL.createObjectURL(res.blob);
        setImage64(url);
        setDialog({
          show: true,
          title: `${name}.${type}`,
          message: '',
          btnText: 'dialog.close',
        });
      })
      .catch((error) => addToast(error.message, 'ERROR'));
  };

  return (
    <>
      {isLoading && (<div className={styles.Spinner}><Spinner isVisible /></div>)}
      {!isLoading && (
        <>
          {image && (
            <div className={styles.IcoFav}>
              <IcoButtonSimple
                id="btn-open-image"
                icon="icon-auge-sichtbarkeit-an"
                handleClick={() => onOpenImage()}
              />
            </div>
          )}

          <div className={`${styles.ContainerImg} ${className} ${backgroundColorWithImage}`}>
            {image && (
              <img
                className={`${styles.ImgAttachment}`}
                id="attachment-image"
                src={image}
                alt=""
                onError={() => setImage('')}
              />
            )}
            {!image && (
              <Box
                alignItems="center"
                className={styles.ImageNotFound}
                display="flex"
                id="attachment-image"
                justifyContent="center"
                p={1}
              >
                <p className={styles.ImageNotFoundText}>
                  <i>
                    {t('summary.imageNotFound')} <br />
                  </i>
                </p>
              </Box>
            )}
            {dialog?.show && (
              <DialogOpenImage
                close={() => setDialog({ ...dialog, show: false })}
                fullWidth
                maxWidth="md"
                image={image64}
                title={dialog.title}
              />
            )}
          </div>
        </>
      )}
    </>
  );
};

export default Image;
